import { render, staticRenderFns } from "./VisitorTracker.vue?vue&type=template&id=5813a28c&"
import script from "./VisitorTracker.vue?vue&type=script&lang=js&"
export * from "./VisitorTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports